import { Modal } from "@ews-admin/global-design-system";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  clearGlobalError,
  selectGlobalErrorCode,
} from "../../../store/reducers/errorSlice";

export const GlobalErrorModal: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const errorCode = useSelector(selectGlobalErrorCode);

  if (!errorCode) return null;

  const message = t(`apiErrors.${errorCode}`, "") || t("apiErrors.default");

  const handleClose = () => {
    dispatch(clearGlobalError());
  };

  return (
    <Modal
      isOpen={true}
      onClose={handleClose}
      title={t("apiErrors.title")}
      variant="error"
      size="sm"
      primaryAction={t("common.close")}
      onPrimaryAction={handleClose}
    >
      <p>{message}</p>
    </Modal>
  );
};
